var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBkash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8956",
    fill: "none",
    stroke: "#707070",
    d: "M0 0H32V32H0z",
    transform: "translate(468 421)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#dd1954}.cls-4{fill:#b30000}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_58097",
    clipPath: "url(#clip-path)",
    transform: "translate(-468 -421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7325",
    transform: "translate(472 426.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48088",
    d: "M736.827-322.015l10.8 1.408-2.56 8.961z",
    className: "cls-3",
    transform: "translate(-736.699 322.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48089",
    d: "M822.643-308.113l8.022 10.668-9.26 4.438-1.152-4.694a7.015 7.015 0 0 1 .171-3.03z",
    className: "cls-3",
    transform: "translate(-811.335 309.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48090",
    d: "M898.053-249.922l-2.987-4.182 5.035-.853z",
    className: "cls-4",
    transform: "translate(-878.423 261.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48091",
    d: "M939.67-254.958l1.878 2.006h-2.731z",
    className: "cls-4",
    transform: "translate(-917.608 261.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48092",
    fill: "#e4170d",
    d: "M847.635-198.822l7.638-3.8-.256.9z",
    transform: "translate(-835.942 215.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48093",
    fill: "#900",
    d: "M788.276-213.66l-3.2 10.753 4.865-3.841z",
    transform: "translate(-779.912 224.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48094",
    d: "M739.91-300.873l-3.115-3.969-1.195.043z",
    className: "cls-4",
    transform: "translate(-735.6 306.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48095",
    fill: "#c00",
    d: "M820.405-214.028c.027.36.068.593.068.593l1.152 4.694 9.26-4.438-.084-.113z",
    transform: "translate(-811.555 225.298)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkash);
export default __webpack_public_path__ + "static/media/bkash.d697fc6be7a985e10712fbc6c593e158.svg";
export { ForwardRef as ReactComponent };